import { formatNumberOneDecimal, formatNumberTwoDecimal,
         formatDollar, formatDollarBillions, formatPercent }          from "../../../utilities/formatNumber.js"


export const projectString = (co_txn, companionArrayFromDict) => {

    console.log("[SUCCESS - ENTERTING NEP TECHNIQUE STEP 3 FOR TILE COMPANION]: Projection")

    let string = ""

    companionArrayFromDict.map((element, index) => {
        console.log("[COUNTER] Companion Field(s) For Tile: ", index + 1)
        // c = short for companion
        const cName     = element.name
        const cField    = element.field
        
        // co_txn = company / transaction that is bar we are hovering over's data object
        const cValue    = co_txn[cField]

        // **==== SECTION: FORMARTTING VALUES DISPLAYED IN TOOLTIP ====** //
        // -- FORMATTING DICTIONARIES -- //
        const nominalFields         = ['ttmRevenue', 'currentYearRevEst', 'nextYearRevEst', 'ttmGrossProfit', 'ttmEbitda'];
        const perShareFields        = ['ttmEps', 'currentYearEpsEst', 'nextYearEpsEst', 'dividendAmount']; 
        const percentageFields      = ['ttmEbitdaMargin', 'currentRevenueGrowth', 'forwardRevenueGrowth']
        
        // -- APPLICATION OF FORMATTING TO VALUE DISPLAYED IN TOOLTIP -- //
        // If N/A, add to string the beautifiedFieldNamePropValue: 'N/A' without field-specific formatting
        // [NOTE]: else if (not separate ifs) - we append to the string rather than early return, so without it an N/A value would fall through and get appended a second time by its format line
        if (cValue === 'N/A')                        string += `${cName}: N/A `;
        // Field Specific Formatting For Tile Companion Values
        else if (nominalFields.includes(cField))     string += `${cName}: ${formatDollarBillions(formatNumberOneDecimal(cValue))} `;
        else if (perShareFields.includes(cField))    string += `${cName}: ${formatDollar(formatNumberTwoDecimal(cValue))} `;
        else if (percentageFields.includes(cField))  string += `${cName}: ${formatPercent(formatNumberOneDecimal(cValue))} `;
    })

    console.log("[RESULT] Projected Tile Companion String For Tooltip afterBody: ", string)
    return string

    /*
        return {
            id:                         row.id,
            ticker:                     row.ticker,
            name:                       row.name,
            enterpriseValue:            abstractedMetrics.enterpriseValue,
            netDebtToMarketEquity:      abstractedMetrics.netDebtToMarketEquity,
            marketCapitalization:       row.marketCapitalization,
            sharePrice:                 row.sharePrice,
            dividendAmount:             row.dividendAmount,
            dividendYield:              abstractedMetrics.dividendYield,
            shares:                     row.shares,
            totalDebt:                  row.totalDebt,
            totalCash:                  row.totalCash,
            priorYearEbitda:            row.priorYearEbitda,
            ttmEbitda:                  row.ttmEbitda,
            ttmEbitdaMultiple:          abstractedMetrics.ttmEbitdaMultiple,
            ttmEbitdaMargin:            abstractedMetrics.ttmEbitdaMargin,
            ttmGrossProfit:             row.ttmGrossProfit,
            ttmGrossMargin:             abstractedMetrics.ttmGrossMargin,
            priorYearRevenue:           row.priorYearRevenue,
            ttmRevenue:                 row.ttmRevenue,
            currentYearRevEst:          row.currentYearRevEst,
            nextYearRevEst:             row.nextYearRevEst,
            ttmRevenueMultiple:         abstractedMetrics.ttmRevenueMultiple,
            currentYearRevenueMultiple: abstractedMetrics.currentYearRevenueMultiple,
            nextYearRevenueMultiple:    abstractedMetrics.nextYearRevenueMultiple,
            currentRevenueGrowth:       abstractedMetrics.currentRevenueGrowth,
            forwardRevenueGrowth:       abstractedMetrics.forwardRevenueGrowth,        
            ttmNetIncome:               row.ttmNetIncome,
            ttmEps:                     abstractedMetrics.ttmEps,
            priorYearNetIncome:         row.priorYearNetIncome,
            priorYearEps:               abstractedMetrics.priorYearEps,
            currentYearEpsEst:          row.currentYearEpsEst,
            nextYearEpsEst:             row.nextYearEpsEst,
            ttmPeMultiple:              abstractedMetrics.ttmPeMultiple,
            currentYearPeMultiple:      abstractedMetrics.currentYearPeMultiple,
            nextYearPeMultiple:         abstractedMetrics.nextYearPeMultiple,
            currentEarningsGrowth:      abstractedMetrics.currentEarningsGrowth,
            forwardEarningsGrowth:      abstractedMetrics.forwardEarningsGrowth,        
            fiftyTwoWeekHigh:           row.fiftyTwoWeekHigh,
            fiftyTwoWeekLow:            row.fiftyTwoWeekLow,
            timestamp:                  row.timestamp,
            ruleOf40:                   abstractedMetrics.ruleOf40,
        }
    */
}

export const projectCompanyFooter = (co) => {

    console.log("[SUCCESS - ENTERTING NEP TECHNIQUE STEP 3 FOR COMPANY FOOTER COMPANION]: Projection")

    const footer = co.name

    console.log(`[RESULT] Projected Company Tooltip Footer Companion: `, footer)
    return footer
}

export const projectTransactionFooter = (txn) => {

    console.log("[SUCCESS - ENTERTING NEP TECHNIQUE STEP 3 FOR TRANSACTION FOOTER COMPANION]: Projection")

    const footer = `Acquirer: ${txn.acquirerName} Target: ${txn.targetName}`

    console.log(`[RESULT] Projected Transaction Tooltip Footer Companion: `, footer)
    return footer
}